import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import testIds from '../ReviewAndAccess/testIds';

type RatingBarProps = {
  label: string;
  value: number; // e.g. 4.5
  max?: number; // default 5
  index: number;
};

const RatingBar = ({ label, value, index, max = 5 }: RatingBarProps) => {
  const { t } = useTranslation();
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));

  return (
    <div
      className={classNames('flex w-full items-center gap-3 justify-start text-base md:text-xl', {
        'md:justify-start': (index + 1) % 3 === 1,
        'md:justify-center': (index + 1) % 3 === 2,
        'md:justify-end': (index + 1) % 3 === 0,
      })}
    >
      <div className="flex items-center gap-2">
        <div className="text-right font-semibold text-teal-600">{value.toFixed(1)}</div>
        <div className="h-4 w-28 rounded bg-gray-50 md:hidden xl:block">
          <div className="h-full rounded bg-teal-600" style={{ width: `${percentage}%` }} />
        </div>
      </div>
      <div className="text-left text-base text-gray-950" data-testid={testIds.review_sub_category}>
        {t(`enum:ReviewSubCategory.${label}`)}
      </div>
    </div>
  );
};

export default RatingBar;
